import { Dropdown, type MenuProps } from 'antd';
import {
  ColumnWidthOutlined,
  EllipsisOutlined,
  FilePdfOutlined,
} from '@ant-design/icons';
import { DataRange } from '../lib/range';
import styles from './RangeMenu.module.css';

/** Props for {@link RangeMenu}. */
export interface RangeMenuProps {
  range: DataRange;
  onChange: (range: DataRange) => void;
  onDownload: () => void;
  downloadDisabled: boolean;
}

const SWITCH_LABELS: Record<DataRange, string> = {
  [DataRange.Operational]: 'Show full data range',
  [DataRange.Full]: 'Show operational data range',
};

/** The "…" menu: switches the charts between the operational window and the full data range, and opens the PDF preview. */
const RangeMenu = ({
  range,
  onChange,
  onDownload,
  downloadDisabled,
}: RangeMenuProps) => {
  const menu: MenuProps = {
    items: [
      {
        key: 'range',
        icon: <ColumnWidthOutlined />,
        label: <span className={styles.label}>{SWITCH_LABELS[range]}</span>,
      },
      {
        key: 'pdf',
        icon: <FilePdfOutlined />,
        disabled: downloadDisabled,
        label: <span className={styles.label}>Download pdf</span>,
      },
    ],
    onClick: ({ key }) => {
      if (key === 'pdf') {
        onDownload();
        return;
      }
      onChange(
        range === DataRange.Operational ? DataRange.Full : DataRange.Operational
      );
    },
  };

  return (
    <Dropdown
      menu={menu}
      trigger={['click']}
      placement='bottomRight'
      classNames={{ root: styles.menu }}
    >
      <button
        type='button'
        className={styles.trigger}
        aria-label='More options'
      >
        <EllipsisOutlined />
      </button>
    </Dropdown>
  );
};

export default RangeMenu;
